import { Text, View } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight } from '~/utils'

export const ReviewCompact = styled(View, theme => {
  return {
    base: {
      flex: 1,
      height: theme.sizingSmall,
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacingInlineOnepulse,
    },
  }
})

export const ReviewCompactTextReviews = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralReadonly,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
  }
})

export const ReviewCompactTextValue = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.bold,
      fontSize: theme.fontSizeFourpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
  }
})
